/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MealPlan from './meal-plan';
import MealPlanDetail from './meal-plan-detail';
import MealPlanUpdate from './meal-plan-update';
import MealPlanDeleteDialog from './meal-plan-delete-dialog';

const MealPlanRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MealPlan />} />
    <Route path="new" element={<MealPlanUpdate />} />
    <Route path=":id">
      <Route index element={<MealPlanDetail />} />
      <Route path="edit" element={<MealPlanUpdate />} />
      <Route path="delete" element={<MealPlanDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MealPlanRoutes;
